var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"poi-categories",attrs:{"role":"menu","aria-label":"Poi's category list"}},_vm._l((_vm.tourCategories),function(category,index){return _c('category-block',{key:index,attrs:{"category":category}})}))}
var staticRenderFns = []

export { render, staticRenderFns }